export default "__VITE_PUBLIC_ASSET__c47b3fe9__"